import React from 'react'
import _ from 'lodash'
import Parent from 'pu-react/components/PriceMatrixCell'

class PriceMatrixCell extends Parent {
  onSelectData() {
    return {
      quantity: this.props.quantity,
      leadTime: this.props.leadTime,
      quote_config_key: this.props.lineItem.quote_config_key,
      supplier: this.props.lineItem.product_key,
      parametersChanged: this.props.parametersChanged,
      unitPrice: this.unitPrice(),
      total: this.totalPrice(),
      row_selected: this.currentRowIdx(),
      column_selected: this.currentColIdx(),
    };
  }

  isSelected() {
    const { lineItem, parameters } = this.props;
    if (parameters === undefined) {
      return false;
    }

    return _.parseInt(parameters.row_selected) === this.currentRowIdx()
      && _.parseInt(parameters.column_selected) === this.currentColIdx()
      && parameters.quote_config_key === lineItem.quote_config_key;
  }
}

export default PriceMatrixCell
